import { mapState } from "vuex";
import MallName from "@/assets/images/mall_name.png";
import Common from "@/libs/Common.js";

export default {
  name: "left_menu",
  data: () => ({
    MallName,
    shop_no: 1,
    sub_menu_on: {
      schedule: "sub_menu_on",
      completion: "",
      detail: "",
      write: "",
      setting: "",
    },
    user_type: sessionStorage.getItem("user_type"),
    mall_name: "",
  }),
  methods: {
    reset: function () {
      Object.assign(this.$data, this.$options.data());
    },
    movePage: function (page_name) {
      // 현재 페이지와 같은 페이지로 이동하려는 경우 방지
      if (this.$route.name === page_name) {
        this.changeSelectMenu(page_name);
        return;
      }

      this.$router.push({
        name: `${page_name}`,
      }).catch(err => {
        // NavigationDuplicated 오류 무시
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router navigation error:', err);
        }
      });
      this.changeSelectMenu(page_name);
    },
    changeSelectMenu: function (page_name) {
      this.sub_menu_on = {
        schedule: "",
        completion: "",
        detail: "",
        write: "",
        setting: "",
      };
      this.sub_menu_on[page_name] = "sub_menu_on";
    },
    handleDownloadGuide() {
      const url = '/static/카페24_공급사_정산앱_사용자_가이드_20250818.pdf';
      window.open(url, '_blank');
    }
  },

  created: async function () {
    this.movePage(this.$route.name);
  },
  mounted: async function () {
    if (sessionStorage.getItem("supply_shop_name")) {
      this.mall_name = sessionStorage.getItem("supply_shop_name");
    }
    if (sessionStorage.getItem("supply_supplier_name")) {
      this.mall_name = sessionStorage.getItem("supply_supplier_name");
    }
  },
};
